import { htmlDecode } from "../../../../../utils/parse";
import { QuestionCard } from "./QuestionCard";

import { MediaWithDescription } from "../MediaWithDescription";
import { useMemo } from "react";

export function HotQuestion({ index, question, attempt, mark, status,checkQuestion }) {
  const corrAns = question.correctAnswers.descriptive[0]?.answer;

   const {answer,file} = useMemo(() => {
     const {answer,file,optionId} = attempt?.answer?.descriptive || {};
     return {
      answer,
      file
     }
    },[question.correctAnswers])

  return (
    <QuestionCard
      index={index}
      question={question}
      attempt={attempt}
      status={status}
      correctAnswer={corrAns}
      mark={mark}
      studentAnswer={{
        text:answer,
        file
      }}
      checkQuestion={checkQuestion}
    >
      <MediaWithDescription mediaUrl={question.images?.questionImg}>
        {question.question}
      </MediaWithDescription>
    </QuestionCard>
  );
}
